import { trigger_interaction } from './Analytics';
export function SelectMapLink() {
    trigger_interaction('DASH SHPE', 'o', 'MAP, MAPLINK');
}

export function SelectMapLocation({ locationId }) {
    trigger_interaction('MAP', 'o', `LOCATION, ${locationId}`);
}